import Cookies from 'js-cookie'

const TokenKey = 'x-access-token'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
const CORP_ID = 'ww7e1ed42bd976f01c';
const AGENT_ID = '1000016';
// 项目为 hash 路由，回调地址必须带 #/login，否则企业微信回调后 code 会丢失
const REDIRECT_URI = encodeURIComponent(window.location.origin+ '/#/login');
// 跳转到企业微信授权页
export const redirectToWechatAuth = () => {
  const authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${CORP_ID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=snsapi_base&agentid=${AGENT_ID}&state=STATE#wechat_redirect`;
  window.location.href = authUrl;
};



// WEBPACK FOOTER //
// ./src/util/auth.js